import * as guidByString from 'uuid-by-string';
import { MedicationPrescription } from '../services/api-client.service';

/**
 * Common e-script order/reference number for EVERY pharmacy integrator:
 *
 *   HBC{practice last 3}-{prescription-derived number}{vendor}
 *   e.g. HBC567-668397DC
 *
 * `HBC` stays the prefix, the vendor tag (each descriptor's `orderNumberSuffix`) sits at the END, and the single dash
 * splits the practice part from the generated part.
 */
export function buildEscriptOrderNumber(prescription: MedicationPrescription, vendorSuffix: string): string {
  const treatingPracticeNumber = prescription.Provider?.TreatingDoctorPracticeNumber ?? '';
  const practiceLastThree = treatingPracticeNumber.slice(-3) || '000';
  return `HBC${practiceLastThree}-${guidToNumber(prescription.MedicationPrescriptionId)}${vendorSuffix}`;
}

/** Converts a GUID to a short numeric value (shared by all vendors; deterministic per prescription). */
function guidToNumber(guid: string): number {
  const generatedGuid = guidByString(guid);
  let numericValue = 0;
  for (let i = 0; i < generatedGuid.length; i++) {
    numericValue += generatedGuid.charCodeAt(i) * Math.pow(16, i);
  }
  const maxDigits = 6;
  const maxValue = Math.pow(10, maxDigits) - 1;
  return numericValue % maxValue;
}
